import TitleText from './TitleText/TitleText';

const SettingContentsList = {
  TitleText,
};

export default SettingContentsList;
